import { Alert, Box, Button, Typography } from "@mui/material";
import * as React from "react";
import { FormProvider } from "react-hook-form";
import GraphicElements from "../../styles/svg/graphic_elements.svg";
import { useResponsive } from "../../hooks/useResponsive";
import mobileBg from "../../styles/svg/login_bg_mobile.svg";
import { useAssets } from "../../reactQuery/domainAssets";
import { getAPIBaseUrl } from "../../utils/constants";
import TenantSiteName from "../../components/TenantSiteName";
import "./auth.scss";
import { CustomButton } from "../../components/Button/Button";
import { RFHTextField } from "../../components/RFH";
import googleIcon from "../../styles/svg/ic_google.svg";
import { Divider } from "@mui/material";
import SubscriptionExpiredPopup from "../../components/SubscriptionExpiredPopup";
import { useLoginFlow } from "./hooks/useLoginFlow";

function Login({ onLogin }) {
  const isMobile = useResponsive("down", "md");
  const { logo } = useAssets();
  const apiUrl = getAPIBaseUrl();
  const {
    methods,
    apiError,
    loading,
    showSubscriptionPopup,
    submit,
    handleGoogleLogin,
    handleForgotPassword,
    handleClosePopup,
    handleFormError,
  } = useLoginFlow({ onLogin });
  const { handleSubmit } = methods;

  return (
    <Box
      component="main"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundImage: `url(${isMobile ? mobileBg : GraphicElements})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "auto",
        minHeight: "100vh",
      }}
      disableGutters={true}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          maxWidth: 440,
          justifyContent: "center",
          padding: "40px 15px",
        }}
      >
        {logo ? (
          <img
            src={`${apiUrl}/${logo}`}
            alt="not found"
            width={isMobile ? 251 : ""}
            className="login_logo tenant-heading-logo"
          />
        ) : (
          <TenantSiteName className="tenant-heading-logo" />
        )}
        <FormProvider {...methods}>
          <Box
            component="form"
            onSubmit={handleSubmit(submit, handleFormError)}
            noValidate
            className="login-form"
          >
            <Typography
              className="text-center black-primary-color mb-4 weight-700"
              component={"h1"}
              variant="h5"
            >
              Welcome to Task Board
            </Typography>
            {apiError && <Alert severity="error">{apiError}</Alert>}

            <RFHTextField
              margin="normal"
              required
              fullWidth
              id="email"
              // label={loginWithEmail ? "Email Address" : "Username"}
              label={"Username / Email"}
              name="email"
              autoComplete="email"
              className="primary-input-field"
              defaultPadding={false}
            />
            <RFHTextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              defaultPadding={false}
            />

            <div className=" forgot-password-div">
              <span className="card-anchor" onClick={handleForgotPassword}>
                Forgot Password
              </span>
            </div>

            <CustomButton
              type="submit"
              fullWidth
              variant="contained"
              className="btn-blue"
              sx={{ mt: "14px", padding: "13px 16px" }}
              disabled={loading}
            >
              Sign In
            </CustomButton>
            <Divider sx={{ mt: "24px", mb: "8px", color: "#919EAB" }}>
              OR
            </Divider>
            <Button
              startIcon={
                <img src={googleIcon} alt="" height="20px" width="20px" />
              }
              variant="outlined"
              size="large"
              className="mt-4 google-login-btn"
              fullWidth
              onClick={handleGoogleLogin}
              disabled={false}
            >
              Sign in with Google
            </Button>
            {/* <Divider sx={{ mt: "24px", mb: "24px", color: "#919EAB" }}>
            OR
          </Divider>
          <Button
            fullWidth
            variant="outlined"
            className="btn-secondary-border"
            sx={{
              padding: "13px 16px",
            }}
            onClick={changeLoginWith}>
            {loginWithEmail ? "Login with LDAP" : "Login with Client"}
          </Button> */}
          </Box>
        </FormProvider>
      </Box>
      <SubscriptionExpiredPopup
        open={showSubscriptionPopup}
        onClose={handleClosePopup}
        disableClose={true}
      />
    </Box>
  );
}

export default Login;
